<template>
  <div>
    <div class="row crm-row pt-5 pr-4">
      <div class="col-lg-4">
        <b-card header="Todo List" header-tag="h4" body-class="mb-3 pb-2">
          <div class="btn orcaBtn text-left" @click="createTodo()">
            <div class="task-section-item-icon d-inline-block">
              <i class="fas fa-plus"></i>
            </div>
            <div class="task-section-item-content d-inline-block">
              {{ 'Create new list' }}
            </div>
          </div>
          <div class="task-section" style="margin-left: 10px;" :style="isNotDefault(todo)? 'display:flex;' : 'display:none;'">
            <div class="task-section-item task-action-wrapper">

              <div class="task-action" @click="editTodo()">
                <div class="task-section-item-icon">
                  <i class="fas fa-edit"></i>
                </div>
                <div class="task-section-item-content">
                  Edit
                </div>
              </div>
              <div class="task-action" @click="deleteTodo()" :style="isNotDefault(todo)? 'display:flex;' : 'display:none;'">
                <div class="task-section-item-icon">
                  <i class="fas fa-trash"></i>
                </div>
                <div class="task-section-item-content">
                  Delete
                </div>
              </div>
            </div>
          </div>
          <ul v-if="todoList.length" :style="isNotDefault(todo)? '' : 'margin-top: 20px;'">
            <li v-for="todo in todoList" :key="todo.id" @click="getTaskList(todo.id, todo)" :class="{ active : todoId === todo.id }">
              {{ todo.displayName }}
            </li>
          </ul>
        </b-card>
      </div>
      <div class="col-lg-4">
        <b-card header="Upcoming tasks list" header-tag="h4" body-class="mb-3 pb-2">
          <div class="btn orcaBtn text-left mb-2" @click="createTask()">
            <div class="task-section-item-icon d-inline-block">
              <i class="fas fa-plus"></i>
            </div>
            <div class="task-section-item-content d-inline-block">
              {{ 'Create new task' }}
            </div>
          </div>
          <ul v-if="tasks.length">
            <li v-for="task in tasks" :key="task.id" @click="getTaskDetail(task.id)" :class="{ active : taskId === task.id }">
              {{ task.title }}
            </li>
          </ul>
        </b-card>
      </div>
      <div class="col-lg-4">
        <b-card header="Event content" header-tag="h4" body-class="mb-3 pb-2">
          <div class="task-section" :style="isEmpty(task)? 'display:none;' : 'display:block;'">
            <div class="task-section-item task-action-wrapper">
              <div class="task-action" @click="markAsCompleted()">
                <div class="task-section-item-icon">
                  <i class="fas fa-check-circle"></i>
                </div>
                <div class="task-section-item-content" :style="task.status === 'completed'? 'text-decoration: line-through;' : ''">
                  {{ task.status === 'completed' ? 'Completed' : 'Mark as completed' }}
                </div>
              </div>
              <div class="task-action" @click="editTask()">
                <div class="task-section-item-icon">
                  <i class="fas fa-edit"></i>
                </div>
                <div class="task-section-item-content">
                  Edit
                </div>
              </div>
              <div class="task-action" @click="deleteTask()">
                <div class="task-section-item-icon">
                  <i class="fas fa-trash"></i>
                </div>
                <div class="task-section-item-content">
                  Delete
                </div>
              </div>
            </div>
            <div class="task-section-item">
              <div class="task-section-item-icon">
                <i class="fas fa-tasks"></i>
              </div>
              <div class="task-section-item-content">
                {{ task.title ? task.title : "" }}
              </div>
            </div>
            <div class="task-section-item">
              <div class="task-section-item-icon">
                <i class="fas fa-calendar"></i>
              </div>
              <div class="task-section-item-content">
                {{ task.dueDateTime ? formatDate(task.dueDateTime.dateTime) : "" }}
              </div>
            </div>
            <div class="task-section-item" :style="task.isReminderOn? 'display:flex;' : 'display:none;'">
              <div class="task-section-item-icon">
                <i class="fas fa-bell"></i>
              </div>
              <div class="task-section-item-content">
                {{ task.isReminderOn ? formatDate(task.reminderDateTime.dateTime) : "" }}
              </div>
            </div>
            <div class="task-section-item">
              <div class="task-section-item-icon">
                <i class="fas fa-adjust"></i>
              </div>
              <div class="task-section-item-content">
                {{ task.status ? getStatusString(task.status) : "" }}
              </div>
            </div>
            <div class="task-section-item">
              <div class="task-section-item-icon">
                <i class="fas fa-sync"></i>
              </div>
              <div class="task-section-item-content" style="text-transform: capitalize;">
                {{ task.recurrence ? task.recurrence.pattern.type : 'None' }}
              </div>
            </div>
            <div class="task-section-item">
              <div class="task-section-item-icon">
                <i class="fas fa-comment-dots"></i>
              </div>
              <div class="task-section-item-content">
                {{ task.body ? task.body.content : '' }}
              </div>
            </div>
          </div>
        </b-card>
      </div>
    </div>
    <TaskModal v-if="showModal" :info="info" :show="showModal" @close="closeTaskModal()"/>
    <TodoModal v-if="showTodoModal" :info="todoInfo" :show="showTodoModal" @close="closeTodoModal()"/>
  </div>
</template>
<script>
import TaskModal from './TaskModal';
import TodoModal from './TodoModal';

export default {
  name: 'tasks',
  components: {
    TaskModal,
    TodoModal
  },
  data() {
    return {
      todoList: [],
      tasks: [],
      taskId: "",
      todoId: "",
      task: {},
      todo: {},
      showModal: false,
      info: {
        task: {},
        todoList: [],
        todoId: "",
        taskId: ""
      },
      showTodoModal: false,
      todoInfo: {
        todo: {},
        todoId: ""
      }
    }
  },
  mounted() {
    this.getTodoList();
  },
  watch: {
    $route(to, from) {
      if (from.name === "create_task" && to.name === "tasks") {
        this.getTaskList(this.todoId);
      }
    }
  },
  methods: {
    isNotDefault(paramTodo) {
      if (this.isEmpty(paramTodo)) return false;
      return paramTodo.wellknownListName !== "defaultList";
    },
    createTodo() {
      this.todoInfo.todo = {};
      this.todoInfo.todoId = "";
      this.showTodoModal = true;
    },
    editTodo() {
      this.todoInfo.todo = this.todo;
      this.todoInfo.todoId = this.todoId;
      this.showTodoModal = true;
    },
    deleteTodo() {
      axios.delete(this.crmApiPath + 'msgraph/todo/lists/' + this.todoId).then(response => {
        if (response.data.is_redirect) {
          window.location.href = response.data.redirect_url;
        }
        else {
          this.getTodoList();
        }
      }).catch(error => console.log(error));
    },
    createTask() {
      this.$router.push('/tasks/create');
    },
    getTaskList(todo_id, paramTodo) {
      this.todoId = todo_id;
      this.todo = paramTodo;
      axios.get(this.crmApiPath + 'msgraph/todo/lists/' + this.todoId + '/' + 'tasks').then(response => {
        if (response.data.is_redirect) {
          window.location.href = response.data.redirect_url;
        }
        else {
          this.tasks = response.data.tasks.data.value;
          if (this.tasks.length) {
            this.task = this.tasks[0];
            this.taskId = this.tasks[0].id;
          }
          else {
            this.task = {};
          }
        }
      }).catch(error => console.log(error));
    },
    getTaskDetail(task_id) {
      this.taskId = task_id;
      let tempTask = this.tasks.filter(function (element) {
        return element.id === task_id;
      });
      if (tempTask.length) {
        this.task = tempTask[0];
      }
      else {
        this.task = {};
      }
    },
    isEmpty(obj) {
      for (let prop in obj) {
        if (obj.hasOwnProperty(prop))
          return false;
      }
      return true;
    },
    getTodoList() {
      axios.get(this.crmApiPath + 'msgraph/todo/lists').then(response => {
        if (response.data.is_redirect) {
          window.location.href = response.data.redirect_url;
        }
        else {
          this.todoList = response.data.lists.data.value;
          this.todoId = this.todoList[0].id;
          this.todo = this.todoList[0];
          this.getTaskList(this.todoId);
        }
      }).catch(error => console.log(error));
    },
    formatDate(str) {
      return this.$moment.utc(str).format('DD/MM/YYYY HH:mm');
    },
    getStatusString(str) {
      if (str === "notStarted") return "Not Started";
      if (str === "inProgress") return "In Progress";
      if (str === "waitingOnOthers") return "Waiting On Others";
      if (str === "deferred") return "Deferred";
      if (str === "completed") return "Completed";
      return "";
    },
    markAsCompleted() {
      this.task.status = "completed";
      let postData = {
        "status": "completed"
      };
      axios.patch(this.crmApiPath + 'msgraph/todo/lists/' + this.todoId + '/tasks/' + this.taskId, postData).then(response => {
        if (response.data.is_redirect) {
          window.location.href = response.data.redirect_url;
        }
        else {}
      }).catch(error => console.log(error));
    },
    deleteTask() {
      this.task = {};
      axios.delete(this.crmApiPath + 'msgraph/todo/lists/' + this.todoId + '/tasks/' + this.taskId).then(response => {
        if (response.data.is_redirect) {
          window.location.href = response.data.redirect_url;
        }
        else {
          this.getTaskList(this.todoId);
        }
      }).catch(error => console.log(error));
    },
    closeTaskModal() {
      this.showModal = false;
      this.getTaskList(this.todoId);
    },
    closeTodoModal() {
      this.showTodoModal = false;
      this.getTodoList();
    },
    editTask() {
      this.showModal = true;
      this.info.task = this.task;
      this.info.todoList = this.todoList;
      this.info.todoId = this.todoId;
      this.info.taskId = this.taskId;
      this.showModal = true;
    }
  },
}
</script>
<style scoped lang="scss">
ul {
  list-style:      none;
  display:         flex;
  flex-direction:  column;
  justify-content: space-between;
}

ul {
  padding-left: 10px;
}

ul li {
  padding:    10px 0 10px 10px;
  cursor:     pointer;
  min-height: 40px;
}

ul li.active {
  background: #ffffff;
  border:     1px solid #eaeaea;
}

.task-section {
  position:       relative;
  background:     white;
  margin:         10px 0;
  border:         1px solid #eaeaea;
  border-radius:  2px;
  display:        flex;
  flex-direction: column;
}

.task-section-item {
  min-height:  40px;
  position:    relative;
  display:     flex;
  align-items: center;
  box-shadow:  24px 25px 0 -24px rgba(0, 0, 0, 0.08);
}

.task-section-item-content {

}

.task-section-item-icon {
  padding-left:  15px;
  padding-right: 15px;
}

.task-action {
  display: flex;
  cursor:  pointer;
}

.task-action-wrapper {
  border-bottom:   1px solid #eaeaea;
  justify-content: space-between;
  padding-right:   15px;
}
</style>
<style lang="scss">

</style>
